export default {
  text: '{{paymentGateway}}-profiel openen',
  text_generic: 'Onboardingprofiel openen',
  toasts: {
    failed_to_create: 'Openen van {{paymentGateway}}-profiel mislukt',
    link_copied: 'Link gekopieerd naar klembord',
    copy_failed: 'Kopiëren van link mislukt',
  },
};
